import { useEffect, useState } from 'react';

import { noop } from 'lib/utils';

const useClickOutside = (ref, callbackFn = noop, config = {}) => {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    const { exclude } = config;

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (exclude) {
          for (const item of exclude) {
            if (item.current.contains(event.target)) {
              return;
            }
          }
        }

        setOpen(false);
        callbackFn(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [ref, setOpen]);

  return [isOpen, setOpen];
};

export default useClickOutside;
